import { Injectable } from '@angular/core';
import { PerformanceWindow } from '../interfaces/performance';
import { Memory } from '../interfaces/memory';

@Injectable({
  providedIn: 'root',
})
export class MonitoringService {
  constructor() {}

  getMemoryUsage(): Memory {
    /**
     * INFO: Some navigators don't have this property, see more: https://developer.mozilla.org/en-US/docs/Web/API/Performance/memory
     */
    const { memory } = window.performance as unknown as PerformanceWindow;
    if (memory) {
      return {
        totalJSHeapSize: this.toMB(memory.totalJSHeapSize!),
        usedJSHeapSize: this.toMB(memory.usedJSHeapSize!),
        jsHeapSizeLimit: this.toMB(memory.jsHeapSizeLimit!),
      };
    }
    return {};
  }

  private toMB(bytes: number) {
    return Number((bytes / (1024 * 1024)).toFixed(2));
  }
}
